import store from '@/store';

export const showWelcomeInstruction = (tours) => {
  // Remove local storage data to enable the tours
  localStorage.removeItem('step_by_step_guides');

  Object.keys(tours).map((tourName) => {
    tours[tourName].stop();
  });

  // Invoke dialog component
  store.commit('SET_GLOBAL_DIALOG', {
    show: true,
    title: 'Welcome',
    content: `
      <p class="mt-5">Would you like to take a quick tour?</p>
    `,
    cancelText: 'Maybe later',
    cancel: () => {
      // Dialog Ends
      store.dispatch('Tour/start', {
        tours: tours,
        tourKey: 'faq',
      });
      store.commit('SET_GLOBAL_DIALOG', {
        show: false,
      });
    },
    confirmText: 'Ok!',
    confirm: () => {
      store.commit('SET_GLOBAL_DIALOG', {
        content: `
          <p class="mt-5">What would you like to use Quescreen for?</p>
        `,
        cancelText: 'Pre employment screening',
        cancel: () => {
          // Show Pre employment Tour
          store.dispatch('Tour/start', {
            tours: tours,
            tourKey: 'welcome_pre_employment',
          });
          store.commit('SET_GLOBAL_DIALOG', {
            show: false,
          });
        },
        confirmText: 'General/existing worker Health Check',
        confirm: () => {
          // Show Health Check Tour
          store.dispatch('Tour/start', {
            tours: tours,
            tourKey: 'welcome_ghc',
          });
          store.commit('SET_GLOBAL_DIALOG', {
            show: false,
          });
        },
      });
    },
    persistent: true,
  });
};
